import isEqual from 'react-fast-compare';
import { handleActions } from 'redux-actions';

import { tsByEmployeeSuccess } from './actions';
import { logoutSuccess } from 'ducks/auth/actions';
import initialState from './states';

export default handleActions(
  {
    [tsByEmployeeSuccess](state, { payload }) {
      if (isEqual(state, payload)) {
        return state;
      }

      return Object.freeze(payload);
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
